import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Theme } from "../Styles/styles";
import { ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet } from "react-router-dom";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import KeyIcon from '@mui/icons-material/Key';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import { GetAccessTokenForm } from "./GetAccessTokenForm";
import { Modal } from "@mui/material";
import { withGetAccessToken } from "./withGetAccessToken";

interface AccessRights {
  readAcess: string;
  writeAccess: string;
  configureAccess: string;
}

const apiUrl = localStorage.getItem("apiUrl");
//const token = process.env.REACT_APP_API_FAKE_TOKEN;

const Layout = () => {

  const token: string | any = localStorage.getItem("idToken");

  const [isAccessTokenModalOpen, setIsAccessTokenModalOpen] =
    React.useState(false);
  const handleCloseAccessTokenModal = () =>
    setIsAccessTokenModalOpen(false);

  const handleOpenAccessTokenModal = () =>
    setIsAccessTokenModalOpen(true);

  const [accessRight, setAccessRight] = React.useState<AccessRights>({
    readAcess: "test/test",
    writeAccess: "test/test",
    configureAccess: "test/test"
  })


  const { user, isAuthenticated, isLoading, loginWithRedirect, logout } =
    useAuth0();

  //const rabbitmqToken = process.env.RAECT_APP_API_FAKE_ACCES_TOKEN ? process.env.RAECT_APP_API_FAKE_ACCES_TOKEN : "brak klucza";
  //const rabbitmqToken = "eyJhbGciOiJIUzI1NiIsImt0eSI6IkhTQSIsInR5cCI6IkpXVCIsImtpZCI6ImlkMSJ9.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.w - m9XSjvrfWPCdp0niDzTFWeEQxsBWZfZDV2DyFAou0"
  //const rabbitmqToken = "eyJhbGciOiJSUzI1NiIsImt0eSI6IlJTQSIsInR5cCI6IkpXVCIsImtpZCI6ImlkMSJ9.eyJpc3MiOiJodHRwczovL215LWRvbWFpbi5hdXRoMC5jb20vIiwic3ViIjoiSlRFQU0iLCJhdWQiOlsicmFiYml0bXEiXSwiYXpwIjoiSlRFQU0iLCJleHAiOjE5MjE1MDc1OTksImlhdCI6MTMxMTI4MDk3MCwic2NvcGUiOlsicmFiYml0bXEud3JpdGU6Ki8qLyoiLCJyYWJiaXRtcS5jb25maWd1cmU6Ki8qLyoiLCJyYWJiaXRtcS5yZWFkOiovKi97c3VifSoiXSwiZXh0cmFfc2NvcGUiOiJyYWJiaXRtcS50YWc6bWFuYWdlbWVudCJ9.aPKCqb0T9wE3_NBf6bKUCzOtRJZ8Z7TkxmXyJqojpBxvqmeaDxk92Im40LxBAsIjhRM5g8pdjMeHEJlD4eIuDPTMFnzp6uqOjs3JjNVHcp4yTHCfkJmKN7F8JCW16F2fzuhKiigmroo2Gu_mbvbWUoCRDF4-IKeKHvT6vs90Iroq9UsvM7pNLx0Io-x1Lkm3petcQzA8laoM6u4GwmmRF0yWQFGLnpY8tTVupHIa4nVwRE59NC_hcbGSg4YSgGAcEf2AsA8eWB-oQjWC7DR2YEDvkUYS2K59oaJa0dMUXbiVyzmmw0uENVq3StTFfrI1suJTO4Mf4B6mcy85nrAEbw";

  const [pageName, setPageName] = React.useState<string>("Strona startowa");
  const [userContextList, setUserContenxtList] = React.useState<string[]>([]);
  const [isAdmin, setIsAdmin] = React.useState<boolean>(false);
  const [selectedContext, setSelectedContext] = React.useState<string>();
  //const [text, setText] = React.useState(rabbitmqToken);

  React.useEffect(() => {
    setSelectedContext(isAdmin ? "ADMIN" : "lll");
    //console.log(selectedContext);
  }, [isAdmin]);


  React.useEffect(() => {

    setSelectedContext(userContextList[0])
  }, [setUserContenxtList]);



  if (isLoading) {
    return <div>Ładuję stronę ...</div>;
  }

  const logOutUser = () => {
    if (isAuthenticated) {
      logout({
        logoutParams: {
          returnTo: `${window.location.origin}/logout`,
        },
      });
    }
  };



  const handleSelectChange = (event: any) => {
    setSelectedContext(event.target.value as string);
  };

  const GetAccessToken = withGetAccessToken({
    apiUrl: apiUrl,
    token: token,
    onCloseButton: handleCloseAccessTokenModal,

  })



  return isAuthenticated ? (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <ThemeProvider theme={Theme}>
          <AppBar
            position="static"
            sx={{ backgroundColor: "#fff", padding: "16px" }}
          >
            <Toolbar sx={{ display: "flex", justifyContent: "center" }}>
              <Typography
                variant="h4"
                textTransform="uppercase"
                color="#9b9b9b"
              >
                {pageName}
              </Typography>

              <Box
                sx={{
                  width: "350px",
                  position: "absolute",
                  right: "30px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={handleOpenAccessTokenModal}>
                  <KeyIcon
                    sx={{
                      fontSize: 26,
                      color: "#363636",
                    }}
                  />
                </IconButton>
                <Typography variant="h5">{user?.name}</Typography>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>

                    <NativeSelect
                      defaultValue={isAdmin ? "ADMIN" : userContextList[0]}
                      onChange={handleSelectChange}
                    >
                      {isAdmin &&
                        <option value="ADMIN">ADMIN</option>
                      }
                      {userContextList.map((el) =>
                        <option value={el}>{el}</option>
                      )}
                    </NativeSelect>

                  </FormControl>
                </Box>
                <IconButton onClick={logOutUser}>
                  <LogoutIcon
                    sx={{
                      fontSize: 26,
                      color: "#363636",
                    }}
                  />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
        </ThemeProvider>
      </Box>

      <Outlet context={[setPageName, setUserContenxtList, setIsAdmin, selectedContext, setSelectedContext,]} />
      <Modal
        open={isAccessTokenModalOpen}
        onClose={handleCloseAccessTokenModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
          }}
        >
          <GetAccessToken />
        </Box>
      </Modal>
    </>
  ) : (
    <ThemeProvider theme={Theme}>
      <Typography variant="h5">Nie jesteś1 zalogowany</Typography>
    </ThemeProvider>

  );

};


export default Layout;

/** 
export default withAuthenticationRequired(Layout, {
  onRedirecting: () => (<div>Przekirowanie na stronę logowania</div>)
});
*/
